import { render, staticRenderFns } from "./BaseLayouts.vue?vue&type=template&id=267065e0"
import script from "./BaseLayouts.vue?vue&type=script&lang=js"
export * from "./BaseLayouts.vue?vue&type=script&lang=js"
import style0 from "./BaseLayouts.vue?vue&type=style&index=0&id=267065e0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports